import { Loading, View } from '@acin/ui-core';
import styled from 'styled-components';

// This named style should be the wrapper for the component i.e. the module
export const RegulationsOverview = styled(View)``;

export const Sentinel = styled.div`
  height: ${(p) => p.theme.spacing.getSize(5)};
  visibility: hidden;
`;

export const LoadingIndicator = styled(Loading)`
  display: block;
  margin: ${(p) => p.theme.spacing.getSize(3)} 0;
`;
